import { get } from 'lodash'
import { CONFIGURATION_KEYS, PROGRESS_STATES } from '../constants/enums'

export const getActivityList = (awardList, isBecomeAssessor) => {
    const filteredActivityList = []

    for (let index = 0; index < awardList.length; ++index) {
        const award = awardList[index]

        const activityList = get(award, 'activities')

        if (isBecomeAssessor) {
            filteredActivityList.push(...activityList.filter(act =>
                get(act, 'activityState.value') === PROGRESS_STATES.activityInProgress.id && get(act, 'assessor') && !get(act, 'isAcceptedByAssessor')))
        } else {
            filteredActivityList.push(...activityList.filter(act =>
                get(act, 'activityState.value') === PROGRESS_STATES.activityAssessment.id && get(act, 'assessor')))
        }
    }
    return filteredActivityList
}

export const isAssessorManagementEnabledForActivity = activity => {
  const valueMap = get(activity, 'configuration.valueMap')

  return valueMap && valueMap[CONFIGURATION_KEYS.manageAssessors.id] || false
}

export const getSection = data => {
    if (get(data, 'activity')) {
        return get(data, 'activity.activitySection.translationText')
    } else if (get(data, 'activityCategory')) {
        return get(data, 'activityCategory.activitySection.translationText')
    } else if (get(data, 'ajEvent')) {
        return get(data, 'ajEvent.activityCategory.activitySection.translationText')
    } else if (get(data, 'residentialProject')) {
        return get(data, 'residentialProject.activityCategory.activitySection.translationText')
    }
}

export const getActivityName = data => {
    if (get(data, 'activity')) {
        return get(data, 'activity.activityCategory.parent.translatedName')
    } else if (get(data, 'activityCategory')) {
        return get(data, 'activityCategory.parent.translatedName')
    } else if (get(data, 'ajEvent')) {
        return get(data, 'ajEvent.activityCategory.parent.translatedName')
    } else if (get(data, 'residentialProject')) {
        return get(data, 'residentialProject.activityCategory.parent.translatedName')
    }
}

export const getCategoryName = data => {
    if (get(data, 'activity')) {
        return get(data, 'activity.activityCategory.translatedName')
    } else if (get(data, 'activityCategory')) {
        return get(data, 'activityCategory.translatedName')
    } else if (get(data, 'ajEvent')) {
        return get(data, 'ajEvent.activityCategory.translatedName')
    } else if (get(data, 'residentialProject')) {
        return get(data, 'residentialProject.activityCategory.translatedName')
    }
}
